import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';

const PopularCourseInfo = props => {
  const history = useHistory();
  const navigateToCourse = () => {
    history.push(`/course/${props.id}`);
  };
  return (
    <div className="p-20px">
      <div
        className="popular-course-container"
        style={{
          background: props.color,
        }}
        onClick={navigateToCourse}
      >
        <img src={props.icon} width={114} height={114} />
        <p className="popular-course-title">{props.title}</p>
        <p className="popular-course-description">{props.description}</p>
      </div>
    </div>
  );
};

PopularCourseInfo.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default PopularCourseInfo;
